<div class="select-container" [formGroup]="group">
  <select
    class="form-control"
    [formControlName]="config.name"
    [id]="config.name"
    [attr.aria-required]="isRequired ? 'true' : 'false'"
    [attr.aria-invalid]="control.hasError ? 'true' : null"
  >
    @if (config.placeholder) {
      <option value="" [disabled]="placeholderOnEmpty" [hidden]="placeholderOnEmpty">
        {{ config.placeholder }}
      </option>
    }
    @for (opt of config.options; track opt) {
      <option [value]="opt.value" [selected]="opt.selected || config.value === opt.value ? 'selected' : null">
        {{ opt.text }}
      </option>
    }
  </select>
  <i class="icon icon-ui-arrow--down"></i>
</div>
